import PropTypes from 'prop-types'
import { createContext, useContext, useMemo } from  "react"
import { useNotificaciones } from '../hooks/useNotificaciones'

const NotificacionesContext = createContext()

const NotificacionesProvider = ({ children }) => {

    const { 
        notifs, 
        indexNotificacionesHook, updateLeerNotificacionHook, 
        updateLeerNotificacionesHook, destroyNotificacionesHook
    } = useNotificaciones()

    const memoVal = useMemo(
        () => ({
            notifs, 
            indexNotificacionesHook, updateLeerNotificacionHook, 
            updateLeerNotificacionesHook, destroyNotificacionesHook
        }),
        [
            notifs, 
            indexNotificacionesHook, updateLeerNotificacionHook, 
            updateLeerNotificacionesHook, destroyNotificacionesHook
        ]
    )

    return (
        <NotificacionesContext.Provider value={memoVal}>
            {children}
        </NotificacionesContext.Provider>
    )

}

NotificacionesProvider.propTypes = {
    children : PropTypes.node
}

const useNotificacionesContext = () => {
    const mixed = useContext(NotificacionesContext)
    return mixed
}

export { useNotificacionesContext , NotificacionesProvider }
